import React from 'react';
import { BoxProps } from '@withjoy/joykit';
import { FormattedEventScheduleFragment, EventScheduleFragment } from '@graphql/generated';
import { TelemetryProvider } from './ScheduleList.telemetry';
import { useScheduleListController } from '@apps/guest/packages/layout-engine/widgets/ScheduleList/ScheduleList.controller';
import { useLayout } from '@shared/context/LayoutProvider';
import { variantStyles } from './ScheduleListV2.constants';
import type { Variant } from './ScheduleList.types';
import { ScheduleListContent } from './components/ScheduleListContent';

export interface ScheduleListProps
  extends Readonly<
    {
      eventId: string;
      eventHandle: string;
      variant?: Variant;
      layout?: string;
    } & BoxProps
  > {}

export interface ScheduleListContentProps
  extends Readonly<{
      eventId: string;
      formattedSchedule: ReadonlyArray<FormattedEventScheduleFragment>;
      tbaSchedule: ReadonlyArray<EventScheduleFragment>;
      eventHandle: string;
      variant?: Variant;
      layout?: string;
      shouldDisplayUnlockButton: Maybe<boolean>;
      handleUnlockDialogClick: () => void;
      unlockButtonText: string;
    }>,
    BoxProps {}

const ScheduleListV2 = React.forwardRef<HTMLDivElement, ScheduleListProps>((props, ref) => {
  const { eventId, eventHandle } = props;
  const { layout } = useLayout();
  const { formattedSchedule, shouldDisplayUnlockButton, loading, tbaSchedule, handleUnlockDialogClick, unlockButtonText } = useScheduleListController(eventHandle);

  if (loading) return <div style={{ height: '300px' }}></div>; // height set to prevent divs from jumping around while page loads

  return (
    <TelemetryProvider context={{ layout, eventId }}>
      <ScheduleListContent
        scheduleListVersion="v2"
        layout={layout}
        {...props}
        variantStyles={variantStyles}
        ref={ref}
        tbaSchedule={tbaSchedule}
        formattedSchedule={formattedSchedule}
        handleUnlockDialogClick={handleUnlockDialogClick}
        shouldDisplayUnlockButton={shouldDisplayUnlockButton}
        unlockButtonText={unlockButtonText}
      />
    </TelemetryProvider>
  );
});
ScheduleListV2.displayName = 'ScheduleListV2';

export { ScheduleListV2 };
